import React from 'react';
import { Card } from 'antd';
import { useNavigate } from 'react-router-dom';

interface FunctionalityCardProps {
  title: string;
  icon: React.ReactNode;
  path: string;
  description?: string;
}

const FunctionalityCard: React.FC<FunctionalityCardProps> = ({
  title,
  icon,
  path,
  description,
}) => {
  const navigate = useNavigate();

  return (
    <Card
      hoverable
      onClick={() => navigate(path)}
      style={{
        textAlign: 'center',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
      bodyStyle={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '32px 24px',
      }}
    >
      <div style={{ fontSize: '48px', marginBottom: '16px', color: '#1890ff' }}>
        {icon}
      </div>
      <div style={{ fontSize: '16px', fontWeight: 500, marginBottom: '8px' }}>
        {title}
      </div>
      {description && (
        <div style={{ fontSize: '14px', color: '#8c8c8c' }}>
          {description}
        </div>
      )}
    </Card>
  );
};

export default FunctionalityCard;
